Ext.define('SA.view.pvt.RankingExportButton', {
    alias: 'widget.pvt-ranking-export-button',
    extend: 'SA.view.MenuButton',

    cls: 'sa-pvt-ranking-export-button',
    icon: 'sa-icon-export',
    text: 'Export',

    onClick() {
        var menu = this.getMenu(false);

        if (menu && SA.view.menu.MenuVisibilityTracker.wasRecentlyVisible(menu)) {
            menu.hide();
        }
        else {
            this.fireEvent('activate');
        }
    }
});